import { useRef, useCallback } from 'react';
import {
  useMeetingSelector,
  useStableEvent
} from '../meeting/meetingProviderContextDef';
import { events, rejectNotJoined } from '../utils';

const NOOP = () => {};

const selectMeeting = s => s.meeting;

/**
 *
 * @param {{
 *  onTranscriptionStateChanged?: Function,
 *  onTranscriptionText?: Function,
 * }} options
 * @returns {{
 *  startTranscription: ( data: Object ) => void
 *  stopTranscription: () => void
 * }}
 */
const useTranscription = ({
  onTranscriptionStateChanged = NOOP,
  onTranscriptionText = NOOP
} = {}) => {
  const meeting = useMeetingSelector(selectMeeting);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;

  useStableEvent(
    events['transcription-state-changed'],
    onTranscriptionStateChanged
  );
  useStableEvent(events['transcription-text'], onTranscriptionText);

  /**
   * @param {{webhookUrl?:string, modelConfig?:any}} config?
   */
  const startTranscription = useCallback(config => {
    if (!meetingRef.current) return rejectNotJoined('startTranscription');
    return meetingRef.current.startTranscription(config);
  }, []);

  const stopTranscription = useCallback(() => {
    if (!meetingRef.current) return rejectNotJoined('stopTranscription');
    return meetingRef.current.stopTranscription();
  }, []);

  return { startTranscription, stopTranscription };
};

export default useTranscription;
